import React from 'react';
import {
  FundScenariosStore,
  KPIStore,
  SnackbarStore,
} from 'stores';

export const stores = {
  fundScenarioStore: new FundScenariosStore(),
  appStore: new SnackbarStore(),
  KPIStore: new KPIStore(),
};

export const storesContext = React.createContext(stores);
